// Copyright (c) StrangeBee 2024

import React, { ReactElement, ReactNode } from 'react';
import { Result } from 'antd';
import { useLocalMessage } from '@Helpers/';

interface WidgetErrorProps {
    message?: ReactNode;
    multiple?: boolean;
}

export const WidgetError = ({ message, multiple = false }: WidgetErrorProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <Result
            status="error"
            title={multiple ? i('app.dashboard.widget.error.multiple') : i('app.dashboard.widget.error.title')}
            subTitle={message || i('app.dashboard.widget.error.description')}
        />
    );
};
